import { FeatureFlagTypes } from '@generated/graphql';
import { DEPOSIT_TRANSFER_TYPE } from '@ovComponents/4-module/workflowCompletion/constants/deposits';
import {
  getOriginOfAccount,
  isParticipantNumberEnabled,
  isParticipantNumberLengthValid,
} from '@ovComponents/4-module/workflowCompletion/subSteps/utils/depositFieldOptions';
import type { TransferContextData } from '@ovComponents/4-module/workflowCompletion/workflowTypes';
import { useOrganizationFeatureFlag } from '../../../../../../hooks/useOrganizationFeatureFlag';

type UseDepositExternalTransferProp = {
  deposit: TransferContextData;
};

export const useDepositExternalTransfer = ({
  deposit,
}: UseDepositExternalTransferProp) => {
  const usTransferFlowEnabled = useOrganizationFeatureFlag(
    FeatureFlagTypes.UsTransferFlow,
  );
  const enableInKind = useOrganizationFeatureFlag(
    FeatureFlagTypes.InKindTransfers,
  );
  const enabledManualInstitutionCreation = useOrganizationFeatureFlag(
    FeatureFlagTypes.AddInstitutionsManuallyInUce,
  );

  const participantNumberEnabled = isParticipantNumberEnabled({
    usTransferFlowEnabled,
    accountType: deposit.subAccount?.account?.type,
  });
  const originAccountType = getOriginOfAccount(
    deposit.subAccount?.account?.type,
  );
  const hasInvalidParticipantNumber =
    participantNumberEnabled &&
    deposit?.type === DEPOSIT_TRANSFER_TYPE.EXTERNAL_TRANSFER &&
    !isParticipantNumberLengthValid(deposit?.participantNumber ?? '');

  return {
    usTransferFlowEnabled,
    enableInKind,
    enabledManualInstitutionCreation,
    participantNumberEnabled,
    originAccountType,
    hasInvalidParticipantNumber,
  };
};
